export const initTimepicker = async (selector, idOffset = 0) => {
    const firstInput = document.querySelector(selector);
    if (!firstInput) return;
    try {
        const module = await import('../modules/timepicker');
        module.initTimepicker(selector, idOffset);
    } catch (error) {
        console.error("Failed to initialize Timepicker:", error);
    }
}